import { FormGroup } from '@angular/forms';
import { DatePicker } from '@com-delta-omnichannel/mach-core-js';
import { CarsWidgetFormType } from '../models/cars-widget-form.interfaces';

import { CommonModule } from '@angular/common';
import { Component, ElementRef, inject } from '@angular/core';
import { CarsWidgetSuperComponent } from '../cars-widget-super-component/cars-widget-super/cars-widget-super.component';
import { CarsWidget } from '../models/cars-widget.interface';
@Component({
  selector: 'idp-car-widget-base',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cars-widget-base.component.html',
  styleUrls: []
})
export class CarsWidgetBaseComponent extends CarsWidgetSuperComponent {
  elementRef = inject(ElementRef);

  protected updateDateDisplay(
    elementId: string,
    dateInstance: DatePicker
  ): void {
    setInterval(() => {
      const displaySpan = document.getElementById(elementId);
      if (!displaySpan) return;
      const selectedDate = dateInstance?.getSelectedDates()?.start;
      if (selectedDate && selectedDate.getTime() > 0) {
        const formatted = selectedDate.toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric'
        });
        displaySpan.textContent = formatted;
        displaySpan.className = 'text-body-copy text-label-md-medium';
      }
    }, 100);
  }

  openPickupDatePicker(): void {
    this.isPickupDatePickerOpen = !this.isPickupDatePickerOpen;
    this.openDatePicker(this.pickUpDateInstance);
  }

  openDropoffDatePicker(): void {
    this.isDropoffDatePickerOpen = !this.isDropoffDatePickerOpen;
    this.openDatePicker(this.dropOffDateInstance);
  }

  displayOptions(): void {
    this.uiStateService.toggleExpandView();
    this.expandView = this.uiStateService.getCurrentExpandView();
  }

  getError(
    errors: {
      locationError: string;
      pickupDateError: string;
      pickupTimeError: string;
      dropoffDateError: string;
      dropoffTimeError: string;
    },
    form: FormGroup<CarsWidgetFormType>
  ): void {
    const result = this.errorHandlingService.processErrors(
      errors,
      form,
      this.elementRef.nativeElement
    );
    this.locationErrorMessage = result.locationErrorMessage;
    this.pickupDateErrorMessage = result.pickupDateErrorMessage;
    this.pickupTimeErrorMessage = result.pickupTimeErrorMessage;
    this.dropoffDateErrorMessage = result.dropoffDateErrorMessage;
    this.dropoffTimeErrorMessage = result.dropoffTimeErrorMessage;
    this.errorCount = result.errorCount;
    this.firstErrorElement = result.firstErrorElement;
  }

  getRequiredElements(content: CarsWidget): boolean {
    return !!(
      document.getElementById(content.pickUpDate.id) &&
      document.getElementById(content.pickUpTimeDropdown.id) &&
      document.getElementById(content.dropOffDate.id) &&
      document.getElementById(content.dropOffTimeDropdown.id)
    );
  }

  override clearPickupDateError(): void {
    this.pickupDateErrorMessage = '';
    this.updateErrorCount();
  }

  updatePickupDateDisplay(): void {
    this.updateDateDisplay('pickup-date-display', this.pickUpDateInstance);
  }

  updateDropoffDateDisplay(): void {
    this.updateDateDisplay('dropoff-date-display', this.dropOffDateInstance);
  }

  resetDatePickers(): void {
    if (this.pickUpDateInstance) {
      this.pickUpDateInstance.clear();
    }
    if (this.dropOffDateInstance) {
      this.dropOffDateInstance.clear();
    }
  }

  clearAllErrors(): void {
    this.isSubmitted = false;
    this.locationErrorMessage = '';
    this.pickupDateErrorMessage = '';
    this.pickupTimeErrorMessage = '';
    this.dropoffDateErrorMessage = '';
    this.dropoffTimeErrorMessage = '';
    this.errorCount = 0;
  }

  handleDisplayOptions(): void {
    this.uiStateService.toggleExpandView();
    this.expandView = this.uiStateService.getCurrentExpandView();
    this.expandEmit.emit(this.expandView);
  }

  clearDropoffDateError(): void {
    this.dropoffDateErrorMessage = '';
    this.updateErrorCount();
  }

  openDatePicker(rangeDatePickerInstance: DatePicker): void {
    if (!rangeDatePickerInstance) return;
    if (rangeDatePickerInstance.isOpen()) {
      rangeDatePickerInstance.close();
    } else {
      rangeDatePickerInstance.open();
    }
  }
}
